import { render } from "./PostponementsList.vue?vue&type=template&id=5cdb8142&scoped=true&ts=true"
import script from "./PostponementsList.vue?vue&type=script&lang=ts"
export * from "./PostponementsList.vue?vue&type=script&lang=ts"

import "./PostponementsList.vue?vue&type=style&index=0&id=5cdb8142&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdb8142"]])

export default __exports__